/// <amd-module name="TFS/Admin/Common/Providers/CustomPeoplePickerProvider" />
import { IIdentity, IPeoplePickerProvider, IdentityType, IPersonaConnections } from "VSSUI/IdentityPicker";
import { PeoplePickerProvider } from "VSS/Features/Identities/IdentityPickerProvider";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssIdentityService, VssIdentityServiceName } from "VSS/Features/Identities/IdentityService";

export class CustomPeoplePickerProvider implements IPeoplePickerProvider {
    private peoplePickerProvider: PeoplePickerProvider;
    private currentPersonas: IIdentity[] = [];
    private readonly identityService: IVssIdentityService;

    constructor(pageContext: IVssPageContext, identityTypes: string[], operationScopes: string[]) {
        this.peoplePickerProvider = new PeoplePickerProvider(pageContext, {
            identityTypes: identityTypes,
            options: {
                MinResults: 5,
                MaxResults: 20
            }
        });
        this.identityService = pageContext.getService<IVssIdentityService>(VssIdentityServiceName);
    }

    public onFilterIdentities = (filter: string, selectedItems?: IIdentity[]) => {
        const suggestions = this.peoplePickerProvider.onFilterIdentities(filter, selectedItems);
        const suggestionsArray: IIdentity[] = suggestions as IIdentity[];
        const suggestionsPromiseLike: Promise<IIdentity[]> = suggestions as Promise<IIdentity[]>;

        if (filter !== "") {
            const identityToAdd = {
                displayName: filter,
                entityId: filter,
                entityType: IdentityType.Custom,
                originDirectory: IdentityType.Custom,
                originId: ""
            } as IIdentity;

            // Check to see if the returned value is an array, if it is then just pass it into the next function.
            // If the returned value is not an array then check to see if it's a promise or PromiseLike. If it is then resolve it asynchronously.
            if (Array.isArray(suggestionsArray)) {
                suggestionsArray.unshift(identityToAdd);
                return suggestionsArray;
            } else if (suggestionsPromiseLike && suggestionsPromiseLike.then) {
                return suggestionsPromiseLike.then(suggestionsArr => {
                    suggestionsArr.unshift(identityToAdd);
                    return suggestionsArray;
                });
            }
        }

        return suggestions;
    };

    public addIdentitiesToMRU = (identities: IIdentity[]): Promise<boolean> => {
        return this.identityService.addMruIdentitiesAsync(identities);
    };

    public getEntityFromUniqueAttribute = (entityId: string): IIdentity => {
        return this.currentPersonas.filter(x => x.entityId === entityId)[0];
    };

    public onRequestConnectionInformation = (entity: IIdentity, getDirectReports?: boolean): IPersonaConnections => {
        return {
            managers: [],
            directReports: []
        };
    };

    public onEmptyInputFocus = (): IIdentity[] => {
        return [];
    };
}
